const Storage = (() => {
    return {
        save(key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        get(key) {
            const item = localStorage.getItem(key);

            if (item) {
                return JSON.parse(item);
            }

            return null;
        },
        remove(key) {
            localStorage.removeItem(key);
        }
    };
})();

export default Storage;



// WEBPACK FOOTER //
// ./src/scripts/storage.js